export default "__VITE_ASSET__D71zG3Nd__"